module.exports = __webpack_public_path__ + "static/img/city_loading.a3e4957.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/city_loading.gif
// module id = /N7/
// module chunks = 0